const o = (r) => {
  var t;
  return r ? typeof r == "string" ? r : n((t = r.props) == null ? void 0 : t.children) : "";
}, n = (r) => {
  var t;
  return r ? typeof r == "string" ? r : r instanceof Array ? r.map(o).join("") : n((t = r.props) == null ? void 0 : t.children) : "";
};
export {
  n as default
};
